<template>
  <div>
    <v-hover>
      <v-chip @click="collect" color="white" text-color="black" class="font-weight-bold" :class="{'pointer': shine}"
              slot-scope="{ hover }">
        <v-avatar>
          <img v-if="shine" :src="require('../assets/CoinShine_animated.gif')" style="margin: -1px 0 0 1px">
          <img v-else :src="require('../assets/CoinShine_static.gif')" style="margin: -1px 0 0 1px">
        </v-avatar>
        {{getUserInfo.scoins}}
      </v-chip>
    </v-hover>
    <v-dialog v-model="rewardDialog.dialog" max-width="320">
      <v-card>
        <v-card-title class="headline">{{ rewardDialog.message }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="warning"
              depressed
              round
              @click="rewardDialog.dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex";

    export default {
        name: "RewardBtn",
        data() {
            return {
                rewardDialog: {
                    dialog: false,
                    message: '',
                    shine: false,
                }
            }
        },
        methods: {
            ...mapActions('auth', ['collectReward']),
            async collect() {
                // if (!this.shine) return
                let resp = await this.collectReward()
                let time = resp.ServerTimeUCT
                this.$store.commit("auth/setRewardTime", time)
                this.setShine()
                if (resp.reward) {
                    this.rewardDialog.message = 'Congratulations!  You received ' + resp.reward + ' SCoins!'
                } else {
                    let date = new Date(time)
                    date = new Date(date.setDate(date.getDate() + 1))
                    date = `${date.toTimeString().slice(0, 5)}, ${date.toDateString().slice(0, 10)}`
                    this.rewardDialog.message = `Your daily 100 SCoins reward will be available starting ${date}. Click the SCoins button after this time.`
                }
                this.rewardDialog.dialog = true
            },
            setShine() {
                let date = new Date(this.RewardMilliSecSinceEpoch)
                this.shine = new Date(date.setDate(date.getDate() + 1)) < new Date()
            }
        },
        computed: {
            ...mapGetters('auth', ['getUserInfo', 'isInfoLoading']),
            ...mapState('auth', {RewardMilliSecSinceEpoch: state => state.user.RewardMilliSecSinceEpoch})
        },
        beforeMount() {
            this.setShine()
        }
    }
</script>

<style scoped>

</style>
